var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 336,
    viewBox: "0 0 224 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2125_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.854 1H12.1464C5.99043 1 1 6.35654 1 12.9642V323.036C1 329.643 5.99043 335 12.1464 335H211.854C218.01 335 223 329.643 223 323.036V12.9642C223 6.35654 218.01 1 211.854 1Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2125_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1893 37C19.6893 37 37.1893 19 37.1893 17C37.1893 19 54.6893 37 57.1893 37C54.6893 37 37.1893 55 37.1893 57C37.1893 55 19.6893 37 17.1893 37Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2125_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.953 164.522C109.398 164.503 106.953 162.988 105.154 160.308C103.354 157.628 102.347 154.002 102.353 150.226C102.359 146.45 103.378 142.832 105.187 140.165C106.995 137.498 109.446 136 112 136C114.554 136 117.005 137.498 118.813 140.165C120.622 142.832 121.641 146.45 121.647 150.226C121.653 154.002 120.646 157.628 118.846 160.308C117.047 162.988 114.602 164.503 112.047 164.522M111.953 164.522H112.047M111.953 164.522C108.774 164.54 105.731 166.422 103.49 169.754C101.249 173.087 99.9938 177.597 100 182.296C100.006 186.994 101.273 191.498 103.523 194.817C105.773 198.136 108.821 200 112 200C115.179 200 118.227 198.136 120.477 194.817C122.727 191.498 123.994 186.994 124 182.296C124.006 177.597 122.751 173.087 120.51 169.754C118.269 166.422 115.226 164.54 112.047 164.522",
    stroke: "black",
    strokeWidth: 9,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2125_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.189 299C168.689 299 186.189 281 186.189 279C186.189 281 203.689 299 206.189 299C203.689 299 186.189 317 186.189 319C186.189 317 168.689 299 166.189 299Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2125_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 336,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2125_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(17 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2125_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 74,
    fill: "white",
    transform: "matrix(-1 0 0 -1 129 205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2125_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(166 279)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8D);
export default __webpack_public_path__ + "static/media/8D.f19244086c2882a4781ffecd34b8b9ee.svg";
export { ForwardRef as ReactComponent };